const layers = {
  CBand: {
     sources: [
      'ku-c-source9',
      'ku-c-source8',
      'ku-c-source7',
      'ku-c-source6',
      'ku-c-source5',
      'ku-c-source4',
      'ku-c-source3',
      'ku-c-source2',
      'ku-c-source1',
     ],
     layers: [
      'ku-c-fill9',
      'ku-c-fill8',
      'ku-c-fill7',
      'ku-c-fill6',
      'ku-c-fill5',
      'ku-c-fill4',
      'ku-c-fill3',
      'ku-c-fill2',
      'ku-c-fill1',
      'ku-c-line9',
      'ku-c-line8',
      'ku-c-line7',
      'ku-c-line6',
      'ku-c-line5',
      'ku-c-line4',
      'ku-c-line3',
      'ku-c-line2',
      'ku-c-line1',
    ]
  },
  BDBand: {
    sources: [
      'ku-bd-source3',
      'ku-bd-source2',
      'ku-bd-source1',
    ],
    layers: [
      'ku-bd-fill3',
      'ku-bd-fill2',
      'ku-bd-fill1',
      'ku-bd-line3',
      'ku-bd-line2',
      'ku-bd-line1',
    ]
  },
  IndoBand: {
    sources: [
      'ku-indo-source4',
      'ku-indo-source3',
      'ku-indo-source2',
      'ku-indo-source1',
    ],
    layers: [
      'ku-indo-fill4',
      'ku-indo-fill3',
      'ku-indo-fill2',
      'ku-indo-fill1',
      'ku-indo-line4',
      'ku-indo-line3',
      'ku-indo-line2',
      'ku-indo-line1',
    ]
  },
  IndiaBand: {
    sources: [
      'ku-india-source5',
      'ku-india-source4',
      'ku-india-source3',
      'ku-india-source2',
      'ku-india-source1',
    ],
    layers: [
      'ku-india-fill5',
      'ku-india-fill4',
      'ku-india-fill3',
      'ku-india-fill2',
      'ku-india-fill1',
      'ku-india-line5',
      'ku-india-line4',
      'ku-india-line3',
      'ku-india-line2',
      'ku-india-line1',
    ]
  },
  PhBand: {
    sources: [
      'ku-ph-source3',
      'ku-ph-source2',
      'ku-ph-source1',
    ],
    layers: [
      'ku-ph-fill3',
      'ku-ph-fill2',
      'ku-ph-fill1',
      'ku-ph-line3',
      'ku-ph-line2',
      'ku-ph-line1',
    ]
  }
}

export function clearMap(map, previousBand) {
  if (previousBand !== '') {
    layers[previousBand].layers.forEach((layerId) => map.removeLayer(layerId));
    layers[previousBand].sources.forEach((sourceId) => map.removeSource(sourceId));
  }
  if (map.getLayer("satelliteLine")) {
    map.removeLayer("satelliteLine");
  }
  if (map.getSource("satelliteLine")) {
    map.removeSource("satelliteLine");
  }
  if (map.getLayer("points")) {
    map.removeLayer("points");
  }
  if (map.getSource("points")) {
    map.removeSource("points");
  }
  return map;
}